import { render } from "./NextPhase.vue?vue&type=template&id=20a6b17b&scoped=true"
import script from "./NextPhase.vue?vue&type=script&lang=js"
export * from "./NextPhase.vue?vue&type=script&lang=js"

import "./NextPhase.vue?vue&type=style&index=0&id=20a6b17b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a6b17b"]])

export default __exports__